import React, { useState, useEffect } from 'react';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import { ImCross } from 'react-icons/im';
import { useSelector, useDispatch } from 'react-redux';
import {
	getAllOrder,
	getOrderDetailsById,
	getUsersAllOrder,
} from '../../../Redux/features/order/orderSlice';
import OrderFilters from './OrderFilters';
import { updateOrderStatus } from '../../../Redux/features/order/orderSlice';
import { toast } from 'react-toastify';
import { COMPRESSED_IMAGE_URL } from '../../../config/config';
import { useLocation, useNavigate } from 'react-router-dom';
import order from '../../images/no_order.png';

const Skeleton = () => (
	<>
		{/* Skeleton Rows */}
		{[...Array(17)].map((_, index) => (
			<tr key={index} className='w-full animate-pulse border'>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-20 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-32 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-60 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-24 mx-auto'></div>
				</td>
				<td className='py-2 px-4'>
					<div className='md:h-6 h-4 bg-gray-300 rounded w-28 mx-auto'></div>
				</td>
			</tr>
		))}
	</>
);

const ITEMS_PER_PAGE = 5;
const OrderLayout = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const pageFromUrl = queryParams.get('page');
	const initialPage = pageFromUrl ? parseInt(pageFromUrl, 10) : 1;

	// Get all the orders using redux
	const { orders, isLoading } = useSelector((state) => state.order);
	const [currentPage, setCurrentPage] = useState(initialPage);

	const allOrder = orders?.allOrders;
	const totalPages = orders?.totalPages;

	const { auth } = useSelector((state) => state.auth);
	const [Filter, setFilter] = useState({
		CustomerName: '',
		Status: '',
		DateFrom: '',
		DateTo: '',
		OrderNumber: '',
		MobileNo: '',
	});

	const role = auth.role;

	const [isInitialFetchDone, setIsInitialFetchDone] = useState(false);

	useEffect(() => {
		// Fetch orders when component loads or when filters/page change
		if (!isLoading && !isInitialFetchDone && orders.length === 0) {
			if (role === 'ADMIN') {
				dispatch(getAllOrder({ data: Filter, page: currentPage }));
			} else if (role === 'USER') {
				dispatch(getUsersAllOrder({ data: Filter, page: currentPage }));
			}
			setIsInitialFetchDone(true); // Set this after first fetch
		}
	}, [dispatch, isLoading, Filter, currentPage, role, isInitialFetchDone, orders.length]);

	const handleNextPage = () => {
		if (currentPage < totalPages) {
			const newPage = currentPage + 1;
			setCurrentPage(newPage);
			fetchOrders(newPage);
		}
	};

	const handlePrevPage = () => {
		if (currentPage > 1) {
			const newPage = currentPage - 1;
			setCurrentPage(newPage);
			fetchOrders(newPage);
		}
	};
	// Handle page number click
	const handlePageNumberClick = (page) => {
		setCurrentPage(page);
		fetchOrders(page);
	};
	const handlePageNumber = (page) => {
		SetCurrentPage(page);
	};
	const fetchOrders = (page) => {
		if (role === 'ADMIN') {
			dispatch(getAllOrder({ data: Filter, page }));
			navigate(`/orderdashboard/?page=${page}`);
		} else if (role === 'USER') {
			dispatch(getUsersAllOrder({ data: Filter, page }));
			navigate(`/order-history?page=${page}`);
		}
	};

	const generatePageNumbers = () => {
		const pages = [];
		const visiblePages = 3;

		if (totalPages <= visiblePages) {
			for (let i = 1; i <= totalPages; i++) {
				pages.push(i);
			}
		} else {
			pages.push(1);
			const startPage = Math.max(2, currentPage - 1);
			const endPage = Math.min(totalPages - 1, currentPage + 1);
			if (startPage > 2) {
				pages.push('...');
			}
			for (let i = startPage; i <= endPage; i++) {
				pages.push(i);
			}
			if (endPage < totalPages - 1) {
				pages.push('...');
			}
			pages.push(totalPages);
		}

		return pages;
	};

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedOrderDetails, setSelectedOrderDetails] = useState([]);
	const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
	const [selectedOrderId, setSelectedOrderId] = useState(null);

	// Handle "Details" button click
	const handleDetailsClick = (Id) => {
		dispatch(getOrderDetailsById(Id)).then((response) => {
			setSelectedOrderDetails(response.payload.orders);
			setIsModalOpen(true);
		});
	};

	// Handle "Status" button click to open status modal
	const handleStatusClick = (Id) => {
		setSelectedOrderId(Id);
		setIsStatusModalOpen(true);
	};

	// Update the status of the order
	const handleStatusChange = (Status) => {
		dispatch(updateOrderStatus({ Id: selectedOrderId, Status })).then((response) => {
			toast.success(response?.payload?.message);
			fetchOrders(currentPage); // Fetch updated orders
			setIsStatusModalOpen(false);
		});
	};

	// Filter the orders based on filter state
	const handleOrderFilter = () => {
		setCurrentPage(1);
		fetchOrders(1);
	};

	// Reset the filters
	const handleReset = () => {
		setFilter({
			CustomerName: '',
			Status: '',
			DateFrom: '',
			DateTo: '',
			OrderNumber: '',
			MobileNo: '',
		});

		setCurrentPage(1);
		fetchOrders(1);
	};
	const [CurrentPage, SetCurrentPage] = useState(1);
	const totalPage = Math.ceil(selectedOrderDetails.length / ITEMS_PER_PAGE);

	const indexOfLastItem = CurrentPage * ITEMS_PER_PAGE;
	const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
	const currentItems = selectedOrderDetails.slice(indexOfFirstItem, indexOfLastItem);

	return (
		<>
			<div className='p-4'>
				{/* Search Bar */}
				<OrderFilters
					Filter={Filter}
					setFilter={setFilter}
					handleOrderFilter={handleOrderFilter}
					handleReset={handleReset}
					role={role}
				/>
				{/* Table */}
				<div className='overflow-x-auto custom-scrollbar pb-2'>
					<table className='min-w-full bg-white table-auto lg:text-base text-sm max-[400px]:text-xs '>
						<thead>
							<tr className='w-full bg-gray-100'>
								<th className='py-2 px-4'>Details</th>
								<th className='py-2 px-4'>Status</th>
								<th className='py-2 px-4'>Customer Name</th>
								<th className='py-2 px-4'>Order No</th>
								<th className='py-2 px-4'>Order Date</th>
							</tr>
						</thead>
						<tbody>
							{isLoading ? (
								// Show skeleton rows while loading
								<>
									<Skeleton />
								</>
							) : (
								// Render orders data
								allOrder?.map((order) => (
									<tr key={order?.Id} className='text-center border-t border-b'>
										<td className='py-2 px-4'>
											<button
												className='bg-red-400 text-white px-4 py-1 rounded text-sm '
												onClick={() => handleDetailsClick(order?.Id)}>
												Details
											</button>
										</td>

										{role === 'USER' && (
											<td className='py-2 md:px-4 px-2'>
												<button
													className={`${getStatusColor(
														order.Status
													)}  md:px-4 px-2 py-1 rounded w-28 cursor-auto text-sm `}
													disabled={order.Status === 'COMPLETED' || order.Status === 'CANCEL'}>
													{order?.Status}
												</button>
											</td>
										)}

										{role === 'ADMIN' && (
											<td className='py-2 px-4'>
												<button
													className={`${getStatusColor(
														order.Status
													)}  md:px-4 px-2 py-1 rounded w-28 cursor-auto text-sm  ${
														order.Status === 'COMPLETED' || order.Status === 'CANCEL'
															? 'cursor-not-allowed'
															: 'cursor-pointer'
													}`}
													onClick={() => handleStatusClick(order?.Id, order?.Status)}
													disabled={order.Status === 'COMPLETED' || order.Status === 'CANCEL'}>
													{order?.Status}
												</button>
											</td>
										)}

										<td className='py-2 px-4'>{order?.Name}</td>
										<td className='py-2 px-4'>{order?.OrderNo}</td>
										<td className='py-2 px-4'>
											{new Date(order?.OrderDate).toLocaleDateString('en-GB')}
										</td>
									</tr>
								))
							)}
						</tbody>
					</table>

					{allOrder?.length === 0 && (
						<div className='flex flex-col justify-center items-center'>
							<img
								src={order}
								alt='Empty Cart'
								className='w-[350px] md:w-[600px] max-[330px]:w-[250px] mb-4'
							/>
						</div>
					)}
				</div>

				{/* Pagination */}
				<div className=' flex justify-center items-center gap-2 lg:absolute bottom-0 left-0 right-0 md:p-4 max-md:mt-4'>
					{currentPage > 1 && (
						<button
							onClick={handlePrevPage}
							className='px-2 py-2 border rounded bg-gray-200 hover:bg-gray-300 text-base'>
							<FaChevronLeft />
						</button>
					)}

					<div className='space-x-2'>
						{generatePageNumbers().map((page, index) =>
							typeof page === 'number' ? (
								<button
									key={index}
									onClick={() => handlePageNumberClick(page)}
									className={`px-3 py-1 border rounded text-base font-semibold ${
										page === currentPage
											? 'bg-[#EF4444] text-white'
											: 'bg-gray-200 hover:bg-gray-300'
									}`}>
									{page}
								</button>
							) : (
								<span key={index} className='text-gray-500'>
									...
								</span>
							)
						)}
					</div>

					{currentPage < totalPages && (
						<button
							onClick={handleNextPage}
							className='px-2 py-2 border rounded bg-gray-200 hover:bg-gray-300 text-base'>
							<FaChevronRight />
						</button>
					)}
				</div>
			</div>

			{/* Status Modal */}
			{isStatusModalOpen && (
				<div className='fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50'>
					<div className='bg-white w-full max-w-sm md:max-w-md p-6 md:p-8 rounded-lg mx-4'>
						<div className='flex justify-between items-center mb-4'>
							<h2 className='text-lg md:text-xl font-medium '>Change Status</h2>
							<button onClick={() => setIsStatusModalOpen(false)} className='text-lg font-bold'>
								<ImCross />
							</button>
						</div>

						<div className=' flex justify-center items-center w-full gap-2'>
							<button
								onClick={() => handleStatusChange('C')}
								className='bg-green-500  px-3 md:px-4 py-2 rounded text-sm md:text-base '>
								Complete
							</button>
							<button
								onClick={() => handleStatusChange('X')}
								className='bg-red-500 px-3 md:px-4 py-2 rounded text-sm md:text-base bg-opacity-80'>
								Cancel
							</button>
						</div>
					</div>
				</div>
			)}

			{/* Order Details Modal */}
			{isModalOpen && (
				<div className='fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50'>
					<div className='bg-white w-full max-w-3xl p-4 md:p-6 lg:w-3/4 lg:max-w-1/2 rounded-lg mx-4 overflow-auto max-h-[90vh]'>
						{/* Modal Header */}
						<div className='flex justify-between items-center mb-4'>
							<h2 className='text-xl md:text-2xl font-semibold'>Details</h2>
							<button
								onClick={() => setIsModalOpen(false)}
								className='text-lg font-bold hover:text-red-500'>
								<ImCross />
							</button>
						</div>

						{/* Table */}
						<div className='overflow-x-auto custom-scrollbar'>
							<table className='min-w-full bg-white table-auto lg:text-base text-sm max-[400px]:text-xs'>
								<thead>
									<tr className='border-b text-left font-medium'>
										<td className='py-2 md:px-4 px-2'>Image</td>
										<td className='py-2 md:px-4 px-2'>Article Name</td>
										<td className='py-2 md:px-4 px-2'>Color</td>
										<td className='py-2 md:px-4 px-2 text-center'>Size</td>
										<td className='py-2 md:px-4 px-2 text-center'>Quantity</td>
										<td className='py-2 md:px-4 px-2'>Price</td>
										<td className='py-2 md:px-4 px-2'>Subtotal</td>
									</tr>
								</thead>
								<tbody>
									{currentItems?.map((item, index) => (
										<tr key={index} className='border-t border-b'>
											<td className='py-2 md:px-4 px-2'>
												<img
													src={`${COMPRESSED_IMAGE_URL}/${item.ImagePath}`}
													alt='Product'
													className='w-12 h-12 md:w-16 md:h-16 object-cover'
												/>
											</td>
											<td className='py-2 md:px-4 px-2'>{item.ArticleCode}</td>
											<td className='py-2 md:px-4 px-2 text-center'>{item.Color}</td>
											<td className='py-2 md:px-4 px-2 text-center'>{item.SizeDetails}</td>
											<td className='py-2 md:px-4 px-2 text-center'>{item.TotalQty}</td>
											<td className='py-2 md:px-4 px-2'>
												<span className=' font-sans'>₹</span>
												{item.DiscountMRP}
											</td>
											<td className='py-2 md:px-4 px-2'>
												<span className=' font-sans'>₹</span>
												{item.MRP}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>

						{/* Pagination Buttons */}
						<div className='mt-2 flex justify-center space-x-1'>
							{Array.from({ length: totalPage }, (_, index) => {
								const page = index + 1;
								return (
									<button
										key={page}
										onClick={() => handlePageNumber(page)}
										className={`px-2 py-1.5 border rounded text-xs font-semibold ${
											page === CurrentPage
												? 'bg-[#EF4444] text-white'
												: 'bg-gray-200 hover:bg-gray-300'
										}`}>
										{page}
									</button>
								);
							})}
						</div>

						{/* Modal Close Button */}
						{/* <div className="mt-6 flex justify-end">
              <button
                className="bg-red-500 text-white px-4 py-2 rounded"
                onClick={() => setIsModalOpen(false)}
              >
                Close
              </button>
            </div> */}
					</div>
				</div>
			)}
		</>
	);
};

function getStatusColor(Status) {
	switch (Status) {
		case 'COMPLETED':
			return 'bg-green-500 , bg-opacity-20 , text-green-800';
		case 'PENDING':
			return 'bg-yellow-500 , bg-opacity-20 , text-yellow-800';
		case 'CANCEL':
			return 'bg-red-500 , bg-opacity-20 , text-red-800';
		default:
			return '';
	}
}

export default OrderLayout;
